import React from 'react';
import { Typography, Tooltip, message } from 'antd';
import { useExpandableList } from '../../hooks/useExpandableList';

const { Text } = Typography;

const ContactInfoSection = ({ contactInfo, type, label, icon, maxInitialItems = 2 }) => {
  const { expanded, toggle } = useExpandableList();
  const filteredInfo = contactInfo?.filter(info => info.type === type) || [];
  const hasMore = filteredInfo.length > maxInitialItems;
  const displayedItems = expanded ? filteredInfo : filteredInfo.slice(0, maxInitialItems);

  const handleCopy = async (value) => {
    try {
      await navigator.clipboard.writeText(value);
      message.success(`${type === 'email' ? 'Email' : 'ATS ID'} copied!`);
    } catch (err) {
      message.error('Failed to copy');
    }
  };

  return (
    <div style={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '6px' }}>
        {React.cloneElement(icon, { style: { marginRight: '8px', color: '#ffffff' } })}
        <Text strong style={{ marginRight: '8px', fontSize: '14px', color: 'rgba(255,255,255,0.9)', whiteSpace: 'nowrap' }}>
          {label}:
        </Text>
      </div>
      <div style={{ marginLeft: '24px', width: type === 'atsId' ? 'calc(100% - 24px)' : 'auto' }}>
        {displayedItems.map((item, index) => (
          <Text
            key={index}
            style={{
              display: 'block',
              fontSize: '14px',
              marginBottom: '2px',
              color: 'rgba(255,255,255,0.8)',
              whiteSpace: 'nowrap',
              cursor: 'pointer',
              transition: 'color 0.2s',
              ...(type === 'atsId' && {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                width: '100%'
              })
            }}
            title={`Click to copy ${item.value}`}
            onClick={() => handleCopy(item.value)}
            onMouseEnter={(e) => e.target.style.color = 'rgba(255,255,255,1)'}
            onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.8)'}
          >
            {item.value}
          </Text>
        ))}
        {hasMore && !expanded && (
          <Tooltip 
            title={filteredInfo
              .slice(maxInitialItems)
              .map(item => item.value)
              .join(', ')}
          >
            <Text 
              style={{ 
                display: 'block', 
                fontSize: '13px', 
                color: 'rgba(255,255,255,0.6)', 
                cursor: 'pointer',
                textDecoration: 'underline',
                whiteSpace: 'nowrap'
              }}
              onClick={toggle}
            >
              + {filteredInfo.length - maxInitialItems} more
            </Text>
          </Tooltip>
        )}
        {expanded && hasMore && (
          <Text 
            style={{ 
              display: 'block', 
              fontSize: '13px',
              color: 'rgba(255,255,255,0.6)', 
              cursor: 'pointer',
              textDecoration: 'underline',
              whiteSpace: 'nowrap'
            }}
            onClick={toggle}
          >
            - Show less
          </Text>
        )}
      </div>
    </div>
  );
};

export default ContactInfoSection;